/* Fix 20: WavGrind product pages (sections/wg-product.liquid).
   - demo players: swaps the browser's player for the WavGrind bar (with the track's waveform when the
     field has one); one track plays at a time
   - sticky bar: once Debut's Add to Cart has scrolled away, a slim bar keeps it on screen
   - preview video: plays only while on screen (and not at all with reduced motion)
   - product cards: Add to Cart without leaving the page, then updates the cart count */
(function () {
  var audios = [];

  function fmt(s) {
    if (!isFinite(s) || s < 0) return '0:00';
    s = Math.floor(s);
    return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
  }

  function player(el) {
    var a = el.querySelector('audio');
    var btn = el.querySelector('.wg-player__btn');
    var bar = el.querySelector('.wg-player__bar');
    var fill = el.querySelector('.wg-player__fill');
    var cur = el.querySelector('.wg-player__time');
    var dur = el.querySelector('.wg-player__dur');
    if (!a || !btn || !bar || !fill) return;
    var label = btn.getAttribute('data-label') || '';
    a.removeAttribute('controls');
    wave(bar);
    audios.push(a);

    function paint() {
      var p = a.duration ? a.currentTime / a.duration : 0;
      fill.style.width = p * 100 + '%';
      bar.style.setProperty('--p', p * 100 + '%');
      bar.setAttribute('aria-valuenow', String(Math.round(p * 100)));
      bar.setAttribute('aria-valuetext', fmt(a.currentTime) + ' of ' + fmt(Math.ceil(a.duration)));
      cur.textContent = fmt(a.currentTime);
    }
    function showDuration() { dur.textContent = fmt(Math.ceil(a.duration)); paint(); }
    if (a.readyState >= 1) showDuration();
    a.addEventListener('loadedmetadata', showDuration);
    a.addEventListener('timeupdate', paint);
    a.addEventListener('play', function () {
      audios.forEach(function (o) { if (o !== a) o.pause(); });
      el.classList.add('is-playing');
      btn.setAttribute('aria-label', 'Pause ' + label);
    });
    a.addEventListener('pause', function () {
      el.classList.remove('is-playing');
      btn.setAttribute('aria-label', 'Play ' + label);
    });
    a.addEventListener('ended', function () { a.currentTime = 0; paint(); });

    btn.addEventListener('click', function () {
      if (a.paused) {
        var p = a.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        a.pause();
      }
    });

    function seekTo(clientX) {
      if (!a.duration) return;
      var r = bar.getBoundingClientRect();
      a.currentTime = Math.min(1, Math.max(0, (clientX - r.left) / r.width)) * a.duration;
      paint();
    }
    var dragging = false;
    bar.addEventListener('pointerdown', function (e) {
      dragging = true;
      if (bar.setPointerCapture) bar.setPointerCapture(e.pointerId);
      seekTo(e.clientX);
    });
    bar.addEventListener('pointermove', function (e) { if (dragging) seekTo(e.clientX); });
    bar.addEventListener('pointerup', function () { dragging = false; });
    bar.addEventListener('pointercancel', function () { dragging = false; });
    bar.addEventListener('keydown', function (e) {
      if (!a.duration) return;
      var step = { ArrowRight: 5, ArrowUp: 5, ArrowLeft: -5, ArrowDown: -5 }[e.key];
      if (e.key === 'Home') a.currentTime = 0;
      else if (e.key === 'End') a.currentTime = a.duration;
      else if (step) a.currentTime = Math.min(a.duration, Math.max(0, a.currentTime + step));
      else return;
      e.preventDefault();
      paint();
    });

    el.classList.add('is-ready');
  }

  // the waveform: 64 heights from data-peaks drawn as an SVG mask on a layer inside the bar
  // (the bar itself stays unmasked, so the whole strip is still clickable)
  function wave(bar) {
    var pk = bar.getAttribute('data-peaks');
    if (!pk) return;
    var hs = pk.split(',').map(Number);
    var rects = '';
    hs.forEach(function (h, i) {
      h = Math.max(6, Math.min(100, h || 0));
      rects += '<rect x="' + i * 3 + '" y="' + (100 - h) / 2 + '" width="2" height="' + h + '"/>';
    });
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + hs.length * 3 + ' 100" preserveAspectRatio="none">' + rects + '</svg>';
    var layer = document.createElement('span');
    layer.className = 'wg-player__wave';
    layer.style.webkitMaskImage = layer.style.maskImage = 'url("data:image/svg+xml,' + encodeURIComponent(svg) + '")';
    bar.appendChild(layer);
    bar.classList.add('has-wave');
  }

  function stickyBar() {
    var bar = document.querySelector('.wg-product [data-wg-sticky]');
    var main = document.querySelector('#shopify-section-product-template .product-form__cart-submit');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var btn = bar.querySelector('[data-wg-sticky-add]');
    // the Outlink app (a few free packs) hides Debut's button and shows its own download link beside it,
    // so watch their shared wrapper and press whichever button is showing
    var spot = main.closest('.product-form__item--submit') || main;
    function target() {
      var out = document.getElementById('outlink_button');
      return out && out.offsetParent ? out : main;
    }
    // Debut's #PageContainer has a transform on desktop, which pins position: fixed to the page instead of
    // the screen, so the bar lives directly in <body>
    document.body.appendChild(bar);
    var past = false, footer = false;
    function update() {
      var on = past && !footer;
      bar.classList.toggle('is-shown', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
    }
    new IntersectionObserver(function (es) {
      past = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      update();
    }).observe(spot);
    var foot = document.querySelector('.site-footer');
    if (foot) new IntersectionObserver(function (es) { footer = es[0].isIntersecting; update(); }).observe(foot);
    // Debut's own button: its cart popup, apps and checks all work as on the top section
    btn.addEventListener('click', function () {
      target().click();
      // Debut shows add-to-cart errors next to its own button only, so bring that into view if one appears
      setTimeout(function () {
        var err = document.querySelector('#shopify-section-product-template .product-form__error-message-wrapper');
        if (err && !err.classList.contains('product-form__error-message-wrapper--hidden')) {
          err.scrollIntoView({ block: 'center' });
        }
      }, 1200);
    });
  }

  function videos() {
    var vids = document.querySelectorAll('.wg-product video[data-wg-autoplay]');
    if (!vids.length) return;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (still || !('IntersectionObserver' in window)) {
      if (still) vids.forEach(function (v) { v.setAttribute('controls', ''); v.removeAttribute('aria-hidden'); });
      else vids.forEach(function (v) { v.autoplay = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var p = e.target.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          e.target.pause();
        }
      });
    }, { threshold: 0.2 });
    vids.forEach(function (v) { io.observe(v); });
  }

  function cards() {
    if (!window.fetch || !window.FormData) return;
    document.querySelectorAll('.wg-product .wg-card__form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var btn = form.querySelector('.wg-card__btn');
        e.preventDefault();
        if (btn.disabled) return;
        btn.disabled = true;
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var label = btn.innerHTML; // apps on the store may have restyled the button: put back whatever it had
        var added = function () {
          btn.textContent = 'Added ✓';
          btn.classList.add('is-added');
          setTimeout(function () { btn.innerHTML = label; btn.classList.remove('is-added'); btn.disabled = false; }, 2500);
        };
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (r) { if (!r.ok) throw new Error(r.status); })
          .then(function () {
            // the item is in the cart now: from here on, never submit the form again (it would add it twice)
            added();
            return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
                document.querySelectorAll('[data-cart-count-bubble]').forEach(function (n) { n.classList.remove('hide'); });
              })
              .catch(function () {});
          }, function () { btn.disabled = false; form.submit(); });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-wg-player]').forEach(player);
    videos();
    cards();
    stickyBar();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
